export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
export const EASE_OUT = 'cubic-bezier(0.2, 0, 0, 1)';
export const EASE_IN = 'cubic-bezier(0.4, 0, 1, 1)';
export const COUNT_UP_MS = 600;
export const CHART_DRAW_IN_MS = 600;

export const prefersReducedMotion = (): boolean => window.matchMedia(REDUCED_MOTION_QUERY).matches;
export const easeOutCubic = (t: number): number => 1 - (1 - t) ** 3;
